import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import {
	Box, CircularProgress, Grid, Typography
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import * as routes from "../../constants/routes";
import { LogoHeaderCommonComponent } from "../common";

import { ExternalUserStyle } from "./sessionStyle";
import { loginUnifyRequest } from "../../actions/ExternalUserActions";
import ForgotScreen from "../../assets/images/forgotScreen.png";

class LoginUnifyComponent extends Component {
	componentDidMount() {
		const { loginUnify, match, history } = this.props;

		if (!match || !match.params || !match.params.id) {
			history.push(routes.PATH_LOGIN);
		}

		loginUnify(match.params.id, history);
	}

	render() {
		const { classes } = this.props;

		return (
			<Grid className={classes.root} container justify="center" alignItems="flex-start">
				<LogoHeaderCommonComponent />
				<Grid
					container
					className={clsx(classes.rootContainer, {
						forgot: true
					})}
				>
					<Grid item xs={6} className={classes.leftColumn}>
						<Typography variant="h1" gutterBottom>
							Login Automatic
						</Typography>
						<Typography variant="body1" gutterBottom>
							{"We're validating the information"}
						</Typography>
						<Box m={3} />
						<CircularProgress />
					</Grid>
					<Grid item xs={6} className={classes.rigthColumn}>
						<img src={ForgotScreen} alt="" className={classes.rigthColumnImg} />
					</Grid>
				</Grid>
			</Grid>
		);
	}
}

LoginUnifyComponent.propTypes = {
	loginUnify: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
	loginUnify: bindActionCreators(loginUnifyRequest, dispatch)
});

export default connect(
	null,
	mapDispatchToProps
)(withRouter(withStyles(ExternalUserStyle)(LoginUnifyComponent)));
